import React from 'react'
const Footer = () => {
    return (
        <>
            <div className="footer" id="footer">
                <div className="footer-inner row">
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 my-contact">
                        <p className="city">city fergana Main st 2022 office</p>
                        <p><a href="tel:+998911054305">+998 (91) 105 43 05</a></p>
                        <p><a href="mailto:raximovshaxzodbek2002@gmail.com">raximovshaxzodbek2002@gmail.com</a></p>
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 footer-navbar row">
                        <div className="col-xxl-6 col-xl-6 col-lg col-md-12 col-sm col-12">
                            <p><a href={"#header"}>Home</a></p>
                            <p><a href={"#about"}>About me</a></p>
                            <p><a href={"#services"}>Services</a></p>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg col-md-12 col-sm col-12">
                            <p><a href={"#experience"}>Experience</a></p>
                            <p><a href={"#portfolio"}>Portfolia</a></p>
                            <p><a href={"#contact"}>Contact</a></p>
                        </div>
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 footer-links">
                        <div className="row">
                            <div className="col">
                                <a href={"https://t.me/webshohdev"}>
                                    <i className="fab fa-telegram"></i>
                                </a>
                            </div>
                            <div className="col">
                                <a href={"https://www.instagram.com/raximovshaxzodbek2002"}>
                                    <i className="fab fa-instagram"></i>
                                </a>
                            </div>
                            <div className="col">
                                <a href={"https://www.facebook.com/profile.php?id=100075132042535"}>
                                    <i className="fab fa-facebook"></i>
                                </a>
                            </div>
                            <div className="col">
                                <a href={"https://www.linkedin.com/in/webshohdev"}>
                                    <i className="fab fa-linkedin"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <p className="copyright">Copyright &copy; Zed IT Academy WebShohDev</p>
                </div>
            </div>
        </>
    )
}

export default Footer